import { render, staticRenderFns } from "./InsightsFilters.vue?vue&type=template&id=23adfd87"
import script from "./InsightsFilters.vue?vue&type=script&lang=js"
export * from "./InsightsFilters.vue?vue&type=script&lang=js"
import style0 from "./InsightsFilters.vue?vue&type=style&index=0&id=23adfd87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports